/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgFloppyDiskBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3846 22V15.0769C17.3846 14.8729 17.3035 14.6772 17.1594 14.533C17.0151 14.3887 16.8194 14.3077 16.6154 14.3077H7.38462C7.1806 14.3077 6.98494 14.3887 6.84069 14.533C6.69643 14.6772 6.61538 14.8729 6.61538 15.0769V22M17.3846 2V7.38462C17.3846 7.58863 17.3035 7.78429 17.1594 7.92854C17.0151 8.0728 16.8194 8.15385 16.6154 8.15385H10.4615C10.2575 8.15385 10.0619 8.0728 9.91762 7.92854C9.77335 7.78429 9.69231 7.58863 9.69231 7.38462V2M22 20.4615C22 20.8695 21.8378 21.2609 21.5494 21.5494C21.2609 21.8378 20.8695 22 20.4615 22H3.53846C3.13043 22 2.73912 21.8378 2.4506 21.5494C2.16209 21.2609 2 20.8695 2 20.4615V8.78462C2.0017 8.38102 2.16193 7.99425 2.44615 7.70769L7.70769 2.44615C7.99425 2.16193 8.38102 2.0017 8.78462 2H20.4615C20.8695 2 21.2609 2.16209 21.5494 2.4506C21.8378 2.73912 22 3.13043 22 3.53846V20.4615Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgFloppyDisk = wrapIcon(SvgFloppyDiskBase);
export default SvgFloppyDisk;
